import { type Ref, computed } from 'vue'
import { assertNever } from '@/helpers'
import type { RingBuilderStoneTypes } from '@/domain/product/ring/ring-builder'
import type { MoneyFragment } from '@/graphql/api'

export function useTotalSaleAmount(
    stone: Ref<RingBuilderStoneTypes | null | undefined>
) {
    const totalSaleAmount = computed((): MoneyFragment => {
        const val = stone.value
        const defaultAmount: MoneyFragment = {
            __typename: 'Money',
            amount: '0',
            currency: 'GBP',
        }

        if (!val) {
            return defaultAmount
        }

        switch (val.__typename) {
            case 'GemsApi_Stone':
            // fallthrough
            case 'NonSkuGemstone':
            // fallthrough
            case 'NonSkuLabGrown':
                return val.salePrice || defaultAmount
            default:
                return assertNever(val, defaultAmount)
        }
    })

    return {
        totalSaleAmount,
    }
}
